import { computed } from 'mobx';

/**
 * 모델명 모델
 * @window w_tb_e001
 * @category 승강기관리코드
 */
export class ElevatorModelModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 제작사
   *
   * **data type** varchar(3)
   */
  readonly manucd: string;

  /**
   * 코드
   *
   * **data type** varchar(3)
   */
  readonly mdcd: string;

  /**
   * 모델명
   *
   * **data type** varchar(20)
   */
  readonly mdnm: string;

  /**
   * 사용유무
   *
   * **data type** char(1)
   */
  readonly useyn: string;

  /**
   * 비고
   *
   * **data type** varchar(100)
   */
  readonly remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  readonly inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  readonly new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.manucd = data.manucd || '';
    this.mdcd = data.mdcd || '';
    this.mdnm = data.mdnm || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
